module.exports = __webpack_public_path__ + "img/智能设备.ecc2a001.png";